import React from 'react';
import { HealthCheckDefinition } from '../../../../services/performanceMetricsService';

export const ChecksTab: React.FC<{ checks: HealthCheckDefinition[] }> = ({ checks }) => (
  <div className="space-y-3">
    <p className="text-sm text-gray-500 mb-4">
      {checks.length} health checks run against every blog post. Each check scores 0-10 severity, weighted by importance.
    </p>
    {checks.map((check) => (
      <div key={check.id} className="border border-gray-200 rounded-lg px-4 py-3">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-medium text-gray-900">{check.name}</h3>
          <span className="text-xs text-gray-400">Weight: {check.weight}</span>
        </div>
        <p className="text-sm text-gray-500 mt-1">{check.description}</p>
        {check.benchmarks && (
          <div className="mt-3 bg-gray-50 rounded px-3 py-2">
            {check.benchmarks.expected_ctr_by_position && (
              <div className="mb-2">
                <div className="text-[10px] text-gray-400 uppercase tracking-wider mb-1">Expected CTR by Position</div>
                <div className="flex flex-wrap gap-x-3 gap-y-0.5 text-xs">
                  {Object.entries(check.benchmarks.expected_ctr_by_position).map(([pos, ctr]) => (
                    <span key={pos} className="text-gray-600">
                      <span className="font-medium text-gray-700">Pos {pos}:</span> {ctr}
                    </span>
                  ))}
                </div>
              </div>
            )}
            {check.benchmarks.severity_scale && (
              <div className="mb-2">
                <div className="text-[10px] text-gray-400 uppercase tracking-wider mb-1">Severity Scale</div>
                <div className="space-y-0.5 text-xs">
                  {Object.entries(check.benchmarks.severity_scale).map(([condition, result]) => (
                    <div key={condition} className="text-gray-600">
                      <span className="font-medium text-gray-700">{condition}:</span> {result}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {check.benchmarks.threshold && (
              <p className="text-xs text-gray-500">{check.benchmarks.threshold}</p>
            )}
            {check.benchmarks.source && (
              <p className="text-[10px] text-gray-400 mt-1">
                Source: {check.benchmarks.source}
                {check.benchmarks.note && <> — {check.benchmarks.note}</>}
              </p>
            )}
            {!check.benchmarks.source && check.benchmarks.note && (
              <p className="text-[10px] text-gray-400 mt-1">{check.benchmarks.note}</p>
            )}
          </div>
        )}
        <div className="mt-2 flex items-center gap-1">
          <span className="text-[10px] text-gray-400 uppercase tracking-wider">ID:</span>
          <code className="text-[10px] text-gray-500 font-mono">{check.id}</code>
        </div>
      </div>
    ))}
  </div>
);
